// Custom mega menu hover behaviors
document.addEventListener('DOMContentLoaded', function() {
  // Get all mega menu containers
  const megaMenuContainers = document.querySelectorAll('[data-header-dropdown]');
  
  megaMenuContainers.forEach(container => {
    // Find the parent button that triggers this container
    const parentButton = document.querySelector(`[data-dropdown-parent="${container.id}"]`);
    
    if (parentButton && container) {
      // Add hover behavior
      parentButton.addEventListener('mouseenter', function() {
        // Find the Alpine.js component and set the menuOpen state
        const alpineComponent = Alpine.$data(container);
        if (alpineComponent) {
          // This assumes you're using Alpine.js menu state tracking
          container.style.display = 'block';
        }
      });
      
      // Keep menu open while hovering on the container
      container.addEventListener('mouseenter', function() {
        container.style.display = 'block';
      });
      
      // Close menu when mouse leaves container
      container.addEventListener('mouseleave', function() {
        container.style.display = 'none';
      });
    }
  });
});




// Overlay Feature
document.addEventListener('DOMContentLoaded', function() {
    // Create the overlay element
    const overlay = document.createElement('div');
    overlay.id = 'mega-menu-overlay';
    overlay.style.cssText = 'position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.5); z-index: 30; display: none;';
    document.body.appendChild(overlay);
    
    // Show overlay when any mega menu is shown
    const menuButtons = document.querySelectorAll('[data-dropdown-parent]');
    menuButtons.forEach(button => {
      button.addEventListener('mouseenter', function() {
        overlay.style.display = 'block';
      });
      
      // Add the menu ID to get the corresponding menu element
      const menuId = button.getAttribute('data-dropdown-parent');
      const menu = document.getElementById(menuId);
      
      if (menu) {
        menu.addEventListener('mouseleave', function() {
          overlay.style.display = 'none';
        });
      }
      
      button.addEventListener('mouseleave', function(e) {
        // Check if we're not hovering over the menu
        if (!menu.contains(e.relatedTarget)) {
          setTimeout(() => {
            if (!menu.matches(':hover')) {
              overlay.style.display = 'none';
            }
          }, 100);
        }
      });
    });
    
    // Close overlay when clicking on it
    overlay.addEventListener('click', function() {
      overlay.style.display = 'none';
      // Close all mega menus
      document.querySelectorAll('[id^="menu"]').forEach(menu => {
        // This depends on your Alpine.js setup - you may need to adjust this
        if (window.Alpine) {
          const alpineData = Alpine.$data(menu.parentElement);
          if (alpineData && alpineData.menuOpen) {
            for (let key in alpineData.menuOpen) {
              alpineData.menuOpen[key] = false;
            }
          }
        }
      });
    });
  });